<template>
  <div class="flex justify-center items-center relative cursor-pointer">
    <input
      ref="input"
      type="file"
      :name="name"
      multiple
      :accept="allowedFileTypes"
      class="absolute h-full w-full opacity-0 cursor-pointer z-10"
      @change="validateLegalConsentForChange"
      @click="validateLegalConsentForClick"
    />
    <div
      class="text-center block float-none text-grey-darker text-sm font-bold w-full"
    >
      <base-icon size="xxl" name="upload-icon-white" class="block mt-4 mb-2" />
      <p v-if="isSaving" class="my-2 px-1">
        {{
          $tc('customization.uploadingDescription', uploadingFiles, [
            uploadingFiles
          ])
        }}
      </p>
      <p v-else class="my-2 px-1">
        {{ $t('customization.uploadDescription') }}
      </p>
      <button
        type="button"
        class="text-white text-sm rounded p-3 focus:outline-none bg-sh-primary w-3/5 mt-2 mb-4 cursor-pointer"
      >
        {{ $t('customization.upload') }}
      </button>
      <p class="my-2 px-1">
        {{ $t('customization.allowedFileTypes') }}
      </p>
    </div>
  </div>
</template>

<script>
import { UPLOAD_FILE_SIZE_LIMIT } from '../../../utils/configure-environment';
import { TrackingMixin } from '@/mixins/gtm-tracking';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';

export default {
  name: 'LegalConsentFileInput',
  mixins: [TrackingMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    allowedFileTypes: {
      type: Array,
      required: true
    },
    isSaving: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    legalConsentGiven: false,
    uploadingFiles: 0
  }),
  methods: {
    validateLegalConsentForClick(event) {
      // console.log(event);
      if (event.detail === 1) {
        this.trackEvent({ action: 'Picture_Upload' });
      }
      if (this.legalConsentGiven) {
        return;
      }
      event.preventDefault();
      this.showLegalConsentModal().then(
        () => this.$refs.input.click(),
        () => {}
      );
    },
    validateLegalConsentForChange() {
      if (this.legalConsentGiven) {
        this.validateAndEmitFiles();
        return;
      }
      this.showLegalConsentModal().then(
        () => this.validateAndEmitFiles(),
        () => (this.$refs.input.value = '')
      );
    },
    showLegalConsentModal() {
      return new Promise((resolve, reject) => {
        this.$vfm.show({
          component: ConfirmationModal,
          bind: {
            messageText: this.$t('customization.uploadLegalAgreement'),
            confirmText: this.$t('customization.uploadLegalAgreementConfirm'),
            declineText: this.$t('customization.uploadLegalAgreementDecline')
          },
          on: {
            confirm: close => {
              close();
              this.legalConsentGiven = true;
              this.trackEvent({ action: 'Picture_UploadConfirm' });
              resolve();
            },
            cancel: close => {
              close();
              this.legalConsentGiven = false;
              this.trackEvent({ action: 'Picture_UploadDeny' });
              reject();
            },
            closed: () => {
              this.legalConsentGiven = false;
              reject();
            }
          }
        });
      });
    },
    validateAndEmitFiles() {
      const fileList = this.$refs.input.files;

      let result = [];
      for (let i = 0; i < fileList.length; i++) {
        if (!this.allowedFileTypes.includes(fileList[i].type)) {
          this.$emit('error', 'IMAGE_TYPE_NOT_ALLOWED', fileList[i]);
        } else if (fileList[i].size > 1024 * 1024 * UPLOAD_FILE_SIZE_LIMIT) {
          this.$emit('error', 'UNSUPPORTED_IMAGE_SIZE', fileList[i]);
        } else {
          result.push(fileList[i]);
        }
      }

      if (result.length > 0) {
        this.uploadingFiles = result.length;
        this.$emit('change', this.name, result);
      }
      this.$refs.input.value = '';
    }
  }
};
</script>
